import { LoginResponseType, TokenSuccessType } from "../../../Types/Authentication/LoginTypes"
export const storageKey = {
    USER:"user_data",
    TOKEN:"token_string",
    currentRoute:"route",
    accessToken:"accessToken",
    refreshToken:"refreshToken",
    createdById:"createdById",
    clinicId:"clinicId",
    groupName:"groupName",
    encounterData:"EncounterData",
    preBookingId:"preBookingId",
    selectId:"selectId",
    searchParamStorageKey:"searchParamKey",
    priorDetailsKey:"priorApprovalPatientDetails",
    data:"data",
    username:"username",
    empName:"empName",
    clinicianID:"clinicianID",
    refresh:"refresh",
    userRoles:"userRoles",
    session:"session",
    tenantClinicId:"tenantClinicId",
    userId:"userId"

}
export const setItem = (key:string,data:any)=>{
    try{
        if(typeof data == "string"){
            window.localStorage.setItem(key,data)
        }else{
            const stringData = JSON.stringify(data || null)
            window.localStorage.setItem(key,stringData)
        }
        return true
    }catch(error){
        return false
    }
}



export const getItem = (key:string):any=>{
    try {
        const data = window.localStorage.getItem(key)
        const parsedData = JSON.parse(data||"null")
        return parsedData
    } catch (error) {
        return null
    }
}

export const getToken = ():TokenSuccessType | null=>{
     try {
        const data = window.localStorage.getItem(storageKey.TOKEN)
        const parsedData : TokenSuccessType | null = JSON.parse(data||"null")
        return parsedData
     } catch (error) {
        return null
     }
}

export const clear = ()=>{
    try {
        window.localStorage.clear()
        return true
    } catch (error) {
        return false
    }
}

export const getConstants = (): {
  clinicId: number;
  userType: number;
  userId: string;
  createdById: number;
  user:LoginResponseType | null
} => {
  const user = getItem(storageKey.USER);
  const clinicId = user?.clinicId || 0;
  const userType = user?.groupId || 0;
  const createdById = user?.userId || 0;
  const userId = user?.userId||0;
  return { clinicId, userType, createdById,user,userId };
};